import { render, staticRenderFns } from "./AvatarBox.vue?vue&type=template&id=0db016ea&"
import script from "./AvatarBox.vue?vue&type=script&lang=js&"
export * from "./AvatarBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports